import { FacePercentageItem } from "../models/face-percentage-model"

export class FacePercentage {

    private gradColors: string[] = [
        "#e74c3c",
        "#ea4846",
        "#ed4550",
        "#ef435a",
        "#f04265",
        "#f0416f",
        "#ef4279",
        "#ee4383",
        "#ec468d",
        "#e94997",
        "#e54da0",
        "#e051aa",
        "#da56b3",
        "#d45bbb",
        "#cd60c4",
        "#c565cb",
        "#bc6ad3",
        "#b26fd9",
        "#a774df",
        "#9c78e5",
        "#8f7de9",
        "#8281ed",
        "#7385f1",
        "#6289f3",
        "#4e8df5",
    ]

    public alertMessage: string | undefined
    private faceData: FacePercentageItem = FacePercentageItem.zeros()

    public adapt(faceData: FacePercentageItem): boolean {

        this.alertMessage = "Awesome, good to go."
        this.faceData = faceData

        const check1: boolean = this.calculateNosePosition()
        const check2: boolean = check1 && this.calculateFaceRotation()
        const check3: boolean = check2 && this.calculateFaceAngleLR()
        const check4: boolean = check3 && this.calculateEyeRatios()
        const check5: boolean = check4 && this.calculateBlur()
        const check6: boolean = check5 && this.calculateFacePercentageAndGradient()

        return check1 && check2 && check3 && check4 && check5 && check6

    }

    calculateBlur(): boolean {

        if (this.faceData.blur_percentage < 75) {
            this.alertMessage = "Image not clear, trying again"
            return false
        }

        return true

    }

    public faceRotationAlert: boolean | undefined
    calculateFaceRotation(): boolean {

        this.faceRotationAlert = false
        const widthP = Math.round((this.faceData.image_width / 100) * 5)
        const rotationDifference = Math.abs(this.faceData.nose_x - this.faceData.chin_x)

        if (rotationDifference > widthP) {
            this.alertMessage = "Please keep your head straight"
            this.faceRotationAlert = true
            return false
        }

        return true

    }

    calculateNosePosition(): boolean {

        const widthP = Math.round((this.faceData.image_width / 100) * 5)
        const heightP = Math.round((this.faceData.image_height / 100) * 5)

        const l: number = this.faceData.image_width / 2 - widthP
        const r: number = this.faceData.image_width / 2 + widthP

        const t: number = this.faceData.image_height / 2 - heightP
        const b: number = this.faceData.image_height / 2 + heightP

        if (this.faceData.nose_x < l || this.faceData.nose_x > r) {
            this.alertMessage = "Please move towards center of camera"
            return false
        }

        if (this.faceData.nose_y < t || this.faceData.nose_y > b) {
            this.alertMessage = "Please move towards center of camera"
            return false
        }

        return true

    }

    calculateEyeRatios(): boolean {

        const eyeRatio: number = ((this.faceData.right_eye_ratio + this.faceData.left_eye_ratio) / 2) * 100

        if (eyeRatio < 15) {
            this.alertMessage = "Please keep eyes open"
            return false
        }

        return true

    }

    public faceAngleLeftAlert: boolean | undefined
    public faceAngleRightAlert: boolean | undefined
    calculateFaceAngleLR(): boolean {

        const angleDif: number = Math.round((Math.abs(this.faceData.face_angle_l_diff) - Math.abs(this.faceData.face_angle_r_diff)) * 100)
        this.faceAngleRightAlert = false
        this.faceAngleLeftAlert = false

        if (angleDif < -10) {
            this.alertMessage = "Please turn head left towards camera"
            this.faceAngleRightAlert = false
            this.faceAngleLeftAlert = true
            return false
        }

        if (angleDif > 10) {
            this.alertMessage = "Please turn head right towards camera"
            this.faceAngleRightAlert = true
            this.faceAngleLeftAlert = false
            return false
        }

        return true

    }

    public facePercentage: number | undefined
    public faceGradientColor: string | undefined
    private calculateFacePercentageAndGradient(): boolean {

        this.facePercentage = Math.round(this.faceData.face_percentage * 100)
        const gradIndex = Math.round((this.facePercentage / 4) * 1.5)
        this.faceGradientColor = this.gradColors[gradIndex]

        if (gradIndex < 20) {
            this.alertMessage = "Please move closer to camera"
            return false
        }

        return true

    }

}